export enum OrganisationTypeEnum {
  Engineius = 1,
  Customer = 2,
  Supplier = 3,
  SupplierAndCustomer = 4,
  SaaSCustomer = 5,
}
